import React from "react";
import { FooterIconButton } from "../../../base/buttons";
import { translate } from "../../../base/i18n";
import { connect } from "../../../base/redux";

import { isChatOpen, SwitchChatButton } from "../../../chat";
import { SwitchParticipantRight } from "../../../participant-right";
import { getCurrentMode, layoutList, setVideoLayoutMode } from "../../../video-layout-mode";

function OpenVideoButton({ t, dispatch, isMobile, isOpend, mode, chatOpen, participantOpen, prevLayoutMode }) {

    const onClick = () => {
        if (layoutList.indexOf(mode) !== -1) return;
        dispatch(setVideoLayoutMode(prevLayoutMode));
    }

    return (
        <>
            { isMobile && chatOpen ? <SwitchChatButton /> 
            : isMobile && participantOpen ? <SwitchParticipantRight />
            : <FooterIconButton mode="video" name={t("device.video")} checked={isOpend} onClick={onClick} /> }
        </>
    )
}

function _mapStateToProps(state) {
    const chatOpen = isChatOpen(state);
    const { isOpen: participantOpen } = state["features/participant-right"];
    const mode = getCurrentMode(state);
    const { prevLayoutMode } = state['features/video-layout-mode'];

    return {
        mode,
        isOpend: layoutList.indexOf(mode) !== -1 ? true : false,
        chatOpen,
        participantOpen,
        prevLayoutMode
    }
}

export default translate(connect(_mapStateToProps)(OpenVideoButton));